"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConvertTypeRegistry = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class ConvertTypeRegistry {
  constructor() {
    (0, _defineProperty2.default)(this, "types", {});
  }
  register(instance) {
    this.types[instance.type] = instance;
    return this;
  }
  get(type) {
    return this.types[type];
  }
  getAll() {
    return Object.values(this.types);
  }
}
exports.ConvertTypeRegistry = ConvertTypeRegistry;
//# sourceMappingURL=ConvertTypeRegistry.js.map